/* eslint-disable prettier/prettier */
import axios from "axios";
const authApi = axios.create({
  //  baseURL: "http://localhost:3012/auth/",
  //  baseURL: "http://165.172.16.35:3012/auth/",
    baseURL :"https://api.mingobierno.gob.bo/siregpenapi/auth/"
});
authApi.interceptors.request.use((config)=>{
  config.headers={
    "x-access-token":localStorage.getItem("token")
  }
  return config
}

)
export default authApi;
